// extracted by mini-css-extract-plugin
module.exports = {"quick-add-products-by-stock-container":"quick-add-products-by-stock-component_quick-add-products-by-stock-container__1gsb9"};